module.exports = __webpack_public_path__ + "static/media/sidebar-1.09342d56.jpg";